<template>
  <focus-trap>
    <div
      tabindex="-1"
      class="modal d-block"
      :class="modalType"
    >
      <div class="modal-dialog modal-dialog-centered modal-557px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">
              {{ title }}
            </h5>
          </div>
          <div class="modal-body">
            {{ message || $t("something_went_wrong") }}
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="html"
              class="mt-2 border rounded"
              v-html="html"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn"
              :class="buttonType"
              @click="close"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
</template>

<script>
export default {
  name: "Error",

  props: {
    title: {
      type: String,
      required: true,
    },

    message: {
      type: String,
      default: null,
    },

    type: {
      type: String,
      default: "error",
    },

    html: {
      type: String,
      default: "",
      required: false,
    },
  },

  computed: {
    modalType() {
      return "modal-" + this.type;
    },

    buttonType() {
      return "btn-" + this.type;
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
